import { FormControl, FormHelperText, Grid } from "@mui/material";
import Field from "components/Field";
import SelectApplication from "components/SelectApplication";
import { useIntl } from "react-intl";

type FormValuesWithGlobalContextValues = {
  applicationId?: string;
};

type GlobalContextFormFieldsProps<T> = {
  values: T;
  disabled?: boolean;
};

const GlobalContextFormFields = <T extends FormValuesWithGlobalContextValues>({
  values,
  disabled,
}: GlobalContextFormFieldsProps<T>) => {
  const { formatMessage: t } = useIntl();

  return (
    <Field name="applicationId" required>
      {({ input, meta }) => (
        <Grid item xs={12}>
          <FormControl fullWidth error={meta.error && meta.submitFailed}>
            <SelectApplication
              {...input}
              value={values.applicationId}
              label={t({ id: "applicationLabel" })}
              disabled={disabled}
              textFieldProps={{
                error: meta.error && meta.submitFailed,
                required: true,
              }}
              required
            />
            {meta.error && meta.submitFailed && (
              <FormHelperText>{meta.error}</FormHelperText>
            )}
          </FormControl>
        </Grid>
      )}
    </Field>
  );
};

export default GlobalContextFormFields;
